import { render, staticRenderFns } from "./assignment-interventions.vue?vue&type=template&id=d7f628fa"
import script from "./assignment-interventions.vue?vue&type=script&lang=js"
export * from "./assignment-interventions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports